export default "__VITE_ASSET__D_7s$_RS__"